var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cmd-checkbox ng-model=\"checkbox\" ng-change=\"check(checkbox)\" aria-label=\"batch-tag-checkbox\"\u003E\u003C\u002Fmd-checkbox\u003E";;return pug_html;};
module.exports = template;